module.exports = __webpack_public_path__ + "static/media/kong.fc0ed7d0.png";